export default __webpack_public_path__ + "static/media/ETEF-15.ace94b51.pdf";